import HeroIllustration from '@/components/illustrations/HeroIllustration'
import { runSubmit, type ToolRunBinding } from './tool-run'
// Generated from the reference HTML (tools/ai-crawl-checker.nogate.html). It may carry hand edits since (SEO, accessibility, server-rendered data): edit it directly, never regenerate over it.
import Link from 'next/link'
import type { CSSProperties, ReactNode } from 'react'
import RefScript from '@/components/shell/RefScript'

/** The reference page's own script, as written. */
const SCRIPT =
  "/* ---------- radar scope (canvas) ---------- */\n  const canvas = $('#scope'), ctx = canvas ? canvas.getContext('2d') : null;\n  if (canvas) {\n  const tags = $$('.scope__tag');\n  const degEl = $('#sweepDeg');\n  // blips: angle (deg), radius fraction, tag index\n  const blips = [\n    { a: 32,  r: .62, t: 0 }, // ChatGPT\n    { a: 118, r: .78, t: 1 }, // Claude\n    { a: 212, r: .50, t: 2 }, // Gemini\n    { a: 296, r: .70, t: 3 }, // Perplexity\n  ];\n  const ink = () => getComputedStyle(document.body).getPropertyValue('--ink').trim() || '#121212';\n  const accent = '#008dcc';\n  let W = 0, H = 0, dpr = 1, angle = 0, last = 0;\n  const resize = () => {\n    const rect = canvas.getBoundingClientRect();\n    dpr = Math.min(2, devicePixelRatio || 1);\n    W = Math.round(rect.width * dpr); H = Math.round(rect.height * dpr);\n    canvas.width = W; canvas.height = H;\n    // position tags\n    const R = rect.width / 2;\n    blips.forEach(b => {\n      const rad = (b.a - 90) * Math.PI / 180;\n      const x = R + Math.cos(rad) * R * b.r, y = R + Math.sin(rad) * R * b.r;\n      const el = tags[b.t]; if (!el) return;\n      el.style.left = x + 'px'; el.style.top = (y - 22) + 'px';\n    });\n  };\n  new ResizeObserver(resize).observe(canvas); resize();\n\n  const draw = (t) => {\n    const dt = last ? Math.min(50, t - last) : 16; last = t;\n    if (!reduced()) angle = (angle + dt * 0.045) % 360;\n    const cx = W / 2, cy = H / 2, R = Math.min(cx, cy) - 2 * dpr;\n    ctx.clearRect(0, 0, W, H);\n    ctx.save(); ctx.translate(cx, cy);\n    const col = ink();\n    // rings\n    ctx.lineWidth = 1 * dpr; ctx.strokeStyle = col; ctx.globalAlpha = .22;\n    [1, .75, .5, .25].forEach(f => { ctx.beginPath(); ctx.arc(0, 0, R * f, 0, Math.PI * 2); ctx.stroke(); });\n    // crosshair + ticks\n    ctx.globalAlpha = .18;\n    ctx.beginPath(); ctx.moveTo(-R, 0); ctx.lineTo(R, 0); ctx.moveTo(0, -R); ctx.lineTo(0, R); ctx.stroke();\n    ctx.globalAlpha = .35;\n    for (let d = 0; d < 360; d += 10) {\n      const rad = d * Math.PI / 180, len = d % 30 === 0 ? 10 : 5;\n      ctx.beginPath();\n      ctx.moveTo(Math.cos(rad) * (R - len * dpr), Math.sin(rad) * (R - len * dpr));\n      ctx.lineTo(Math.cos(rad) * R, Math.sin(rad) * R); ctx.stroke();\n    }\n    // sweep trail (conic)\n    const a0 = (angle - 90) * Math.PI / 180;\n    const grad = ctx.createConicGradient ? ctx.createConicGradient(a0 - Math.PI * 0.55, 0, 0) : null;\n    ctx.globalAlpha = 1;\n    if (grad) {\n      grad.addColorStop(0, 'rgba(0,141,204,0)');\n      grad.addColorStop(0.55, 'rgba(0,141,204,.40)');\n      grad.addColorStop(0.5501, 'rgba(0,141,204,0)');\n      grad.addColorStop(1, 'rgba(0,141,204,0)');\n      ctx.fillStyle = grad;\n      ctx.beginPath(); ctx.arc(0, 0, R, 0, Math.PI * 2); ctx.fill();\n    }\n    // sweep arm\n    ctx.strokeStyle = accent; ctx.lineWidth = 2 * dpr; ctx.globalAlpha = 1;\n    ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(Math.cos(a0) * R, Math.sin(a0) * R); ctx.stroke();\n    // blips\n    blips.forEach(b => {\n      const rad = (b.a - 90) * Math.PI / 180;\n      const x = Math.cos(rad) * R * b.r, y = Math.sin(rad) * R * b.r;\n      // how recently the sweep passed: 0..1 (1 = just now)\n      let diff = (angle - b.a + 360) % 360; const heat = Math.max(0, 1 - diff / 110);\n      ctx.beginPath(); ctx.arc(x, y, 3.5 * dpr, 0, Math.PI * 2);\n      ctx.fillStyle = col; ctx.globalAlpha = .35 + heat * .65; ctx.fill();\n      if (heat > 0) {\n        ctx.beginPath(); ctx.arc(x, y, (6 + (1 - heat) * 26) * dpr, 0, Math.PI * 2);\n        ctx.strokeStyle = accent; ctx.lineWidth = 1.2 * dpr; ctx.globalAlpha = heat * .9; ctx.stroke();\n      }\n      const el = tags[b.t]; if (el) el.classList.toggle('is-hot', heat > 0.15);\n    });\n    // center\n    ctx.globalAlpha = 1; ctx.fillStyle = col;\n    ctx.beginPath(); ctx.arc(0, 0, 3 * dpr, 0, Math.PI * 2); ctx.fill();\n    ctx.restore();\n    if (degEl) degEl.textContent = String(Math.round(angle)).padStart(3, '0') + '\u00b0';\n    requestAnimationFrame(draw);\n  };\n  requestAnimationFrame(draw);\n  }\n\n  \n;\n\n(() => {\n  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('reduce-motion');\n\n  // ---- instrument: adds .on when visible (CSS primitives animate), counts [data-num], Replay re-runs\n  const inst = document.getElementById('inst');\n  if (inst) {\n    const nums = [...inst.querySelectorAll('[data-num]')];\n    const count = () => nums.forEach(el => {\n      const end = parseFloat(el.dataset.num), suf = el.dataset.suffix || '', dec = +(el.dataset.dec || 0), dur = reduced() ? 1 : 1100, t0 = performance.now();\n      const s = t => { const p = Math.min(1, (t - t0) / dur), k = 1 - Math.pow(1 - p, 3); el.textContent = (end * k).toFixed(dec) + suf; if (p < 1) requestAnimationFrame(s); };\n      requestAnimationFrame(s);\n    });\n    const run = () => { inst.classList.remove('on'); void inst.offsetWidth; requestAnimationFrame(() => { inst.classList.add('on'); count(); }); };\n    new IntersectionObserver((es, io) => es.forEach(e => { if (e.isIntersecting) { setTimeout(run, 250); io.disconnect(); } }), { threshold: .35 }).observe(inst);\n    const rp = document.getElementById('instReplay'); if (rp) rp.addEventListener('click', run);\n  }\n\n  // ---- embed tabs + copy (badge page)\n  const tabs = document.getElementById('embedTabs');\n  if (tabs) {\n    tabs.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; [...tabs.children].forEach(x => x.setAttribute('aria-selected', String(x === b))); document.querySelectorAll('.snip [role=\"tabpanel\"]').forEach(p => p.classList.toggle('is-on', p.dataset.panel === b.dataset.tab)); });\n    document.querySelectorAll('[data-copy]').forEach(b => b.addEventListener('click', async () => { try { await navigator.clipboard.writeText(b.dataset.copy); } catch (_) {} b.classList.add('is-done'); const t = b.innerHTML; b.lastChild.textContent = 'Copied'; setTimeout(() => { b.classList.remove('is-done'); b.innerHTML = t; }, 1400); }));\n  }\n\n  // ---- sub nav scrollspy + dark/accent adaptation (same as the service pages)\n  const sub = document.getElementById('subnav'); if (!sub) return;\n  const links = [...sub.querySelectorAll('a')], targets = links.map(a => document.querySelector(a.getAttribute('href'))).filter(Boolean);\n  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) links.forEach(l => l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id)); }), { rootMargin: '-35% 0px -55% 0px' });\n  targets.forEach(t => io.observe(t));\n  const sheets = [...document.querySelectorAll('.sheet--ink, .sheet--accent')];\n  const last = document.getElementById(sub.dataset.last);\n  const band = () => {\n    const y = 72 + 26; let dark = false, accent = false;\n    for (const s of sheets) { const r = s.getBoundingClientRect(); if (r.top <= y && r.bottom > y) { accent = s.classList.contains('sheet--accent'); dark = !accent; break; } }\n    sub.classList.toggle('is-dark', dark); sub.classList.toggle('is-accent', accent);\n    if (last) sub.classList.toggle('is-gone', last.getBoundingClientRect().bottom < y);\n  };\n  addEventListener('scroll', band, { passive: true }); addEventListener('resize', band); band();\n})();\n"

export default function ToolAiCrawlCheckerRef({
  run,
  form,
  output,
}: {
  run?: ToolRunBinding
  form?: ReactNode
  output?: ReactNode
}) {
  return (
    <>
      {' '}
      <div id='top'>
        {' '}
        <section
          className='sheet thero tpage'
          id='run'
          data-rail='Run'
          data-slot='hero'
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='hero__top'>
              {' '}
              <span className='eyebrow' data-slot='hero.eyebrow'>
                {'Tools / 01 · Site audit'}
              </span>{' '}
              <span className='mono' data-slot='hero.scope'>
                {'Free · tests 17 bots · result in-page'}
              </span>{' '}
            </div>{' '}
            <div className='thero__grid'>
              {' '}
              <div className='thero__copy'>
                {' '}
                <div className='thero__tags' data-slot='hero.tags'>
                  <span className='chip chip--free'>{'Free'}</span>
                  <span className='chip'>{'Site audit'}</span>
                </div>{' '}
                <h1 className='h-display h1' id='heroTitle' data-slot='hero.h1'>
                  <span className='word'>
                    <span>Can</span>
                  </span>{' '}
                  <span className='word'>
                    <span>AI</span>
                  </span>{' '}
                  <span className='word'>
                    <span>bots</span>
                  </span>{' '}
                  <span className='word'>
                    <span>find</span>
                  </span>{' '}
                  <span className='serif'>
                    <span className='word'>
                      <span>your</span>
                    </span>{' '}
                    <span className='word'>
                      <span>content?</span>
                    </span>
                  </span>
                </h1>{' '}
                <p className='lede' data-reveal='' data-slot='hero.sub'>
                  {
                    'Check access policies for 17 crawlers, including OpenAI and Claude search, browsing, and training agents.'
                  }
                </p>{' '}
                <div data-reveal='fade'>
                  {form ?? (
                    <form
                      className='run'
                      id='runForm'
                      data-slot='hero.form'
                      noValidate
                      onSubmit={runSubmit(run)}
                    >
                      {' '}
                      <label className='run__field'>
                        <span>{'Website URL'}</span>
                        <input
                          type='text'
                          name='f0'
                          placeholder='Enter a URL (e.g. example.com)'
                          autoComplete='off'
                          inputMode='url'
                          value={run ? (run.values[0] ?? '') : undefined}
                          onChange={
                            run
                              ? e => run.onChange(0, e.target.value)
                              : undefined
                          }
                          onBlur={
                            run?.onBlur ? () => run.onBlur?.(0) : undefined
                          }
                          disabled={run?.loading}
                        />
                      </label>{' '}
                      <div className='run__actions'>
                        <button
                          className='btn btn--accent'
                          type='submit'
                          disabled={run?.loading}
                        >
                          {'Analyze'}
                          <svg
                            className='arrow'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='1.8'
                          >
                            <path d='M5 12h14M13 6l6 6-6 6' />
                          </svg>
                        </button>
                        <button
                          type='button'
                          className='btn btn--ghost btn--sm'
                          data-example='pixelmojo.io'
                          onClick={run?.onExample}
                        >
                          {'Try pixelmojo.io'}
                        </button>
                      </div>{' '}
                      <p className='run__note' data-slot='hero.note'>
                        <i />
                        <span>
                          {
                            'One free audit per email. Verify with a 6-digit code to view it.'
                          }
                        </span>
                      </p>{' '}
                      {run?.error ? (
                        <p className='run__note run__error' role='alert'>
                          <i />
                          {run.error}
                        </p>
                      ) : null}
                    </form>
                  )}
                </div>{' '}
              </div>{' '}
              <aside
                className='inst inst--art'
                id='inst'
                data-reveal='fade'
                data-slot='hero.instrument'
                data-glyph='crawl'
              >
                {' '}
                <div className='inst__bar'>
                  <b>{'AI Crawl Checker'}</b>
                  <span className='inst__state'>
                    <i />
                    {'Preview'}
                  </span>
                </div>{' '}
                <div className='inst__canvas'>
                  <HeroIllustration variant='crawl'>
                    <circle
                      cx='70'
                      cy='46'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '0' } as CSSProperties}
                    />
                    <circle
                      cx='114'
                      cy='46'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '1' } as CSSProperties}
                    />
                    <circle
                      cx='158'
                      cy='46'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '2' } as CSSProperties}
                    />
                    <circle
                      cx='202'
                      cy='46'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '3' } as CSSProperties}
                    />
                    <circle
                      cx='246'
                      cy='46'
                      r='10'
                      className='gd no'
                      style={{ '--i': '4' } as CSSProperties}
                    />
                    <circle
                      cx='290'
                      cy='46'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '5' } as CSSProperties}
                    />
                    <circle
                      cx='70'
                      cy='94'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '6' } as CSSProperties}
                    />
                    <circle
                      cx='114'
                      cy='94'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '7' } as CSSProperties}
                    />
                    <circle
                      cx='158'
                      cy='94'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '8' } as CSSProperties}
                    />
                    <circle
                      cx='202'
                      cy='94'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '9' } as CSSProperties}
                    />
                    <circle
                      cx='246'
                      cy='94'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '10' } as CSSProperties}
                    />
                    <circle
                      cx='290'
                      cy='94'
                      r='10'
                      className='gd no'
                      style={{ '--i': '11' } as CSSProperties}
                    />
                    <circle
                      cx='70'
                      cy='142'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '12' } as CSSProperties}
                    />
                    <circle
                      cx='114'
                      cy='142'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '13' } as CSSProperties}
                    />
                    <circle
                      cx='158'
                      cy='142'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '14' } as CSSProperties}
                    />
                    <circle
                      cx='202'
                      cy='142'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '15' } as CSSProperties}
                    />
                    <circle
                      cx='246'
                      cy='142'
                      r='10'
                      className='gd ok'
                      style={{ '--i': '16' } as CSSProperties}
                    />
                    <text x='70' y='200' textAnchor='start' className='lab'>
                      {'ALLOWED · 15'}
                    </text>
                    <text x='290' y='200' textAnchor='end' className='lab'>
                      {'BLOCKED · 2'}
                    </text>
                    <text x='180' y='216' textAnchor='middle' className=''>
                      {'17 USER-AGENTS · HEAD REQUESTS'}
                    </text>
                  </HeroIllustration>
                </div>{' '}
                <div className='inst__foot'>
                  <span data-slot='hero.inst_note'>
                    {'Illustrative · 17 user-agents · HEAD requests'}
                  </span>
                  <button
                    className='inst__replay'
                    type='button'
                    id='instReplay'
                  >
                    {'Replay '}
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M4 12a8 8 0 1 0 2.3-5.7M4 4v5h5' />
                    </svg>
                  </button>
                </div>{' '}
              </aside>{' '}
            </div>{' '}
          </div>{' '}
          {output ? (
            <div className='container tool-output'>{output}</div>
          ) : null}
        </section>{' '}
        <div className='subnav' id='subnav' data-last='related'>
          {' '}
          <div className='container subnav__inner'>
            {' '}
            <a href='#about'>
              <i />
              {'What it does'}
            </a>
            <a href='#checks'>
              <i />
              {'What we check'}
            </a>
            <a href='#scoring'>
              <i />
              {'Scoring'}
            </a>
            <a href='#research'>
              <i />
              {'Research'}
            </a>
            <a href='#related'>
              <i />
              {'Related tools'}
            </a>{' '}
            <span className='subnav__spacer' />{' '}
            <span className='mono'>
              {'Free · tests 17 bots · result in-page'}
            </span>{' '}
          </div>{' '}
        </div>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='about'
          data-rail='What it does'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head' data-reveal=''>
              {' '}
              <span className='eyebrow'>{'01 / What it does'}</span>{' '}
              <h2 className='h-display h2' data-slot='kicker'>
                {'Ranking on Google says nothing about '}
                <span className='serif'>{'AI access.'}</span>
              </h2>{' '}
            </div>{' '}
            <div className='about'>
              {' '}
              <div className='about__copy' data-reveal='' data-slot='intro'>
                <p className='lede'>
                  {
                    'AI search engines like ChatGPT, Perplexity, and Gemini use their own web crawlers to index content. Each bot has a unique user-agent, and many websites accidentally block them through robots.txt rules written for traditional search.'
                  }
                </p>
                <p>
                  {
                    'An AI crawl check audits your site against 17 crawler user-agents, separates retrieval access from training policy, and flags missing structured data and llms.txt files that help AI models understand your content. Without this visibility, your site may be invisible to AI search results even if it ranks well on Google.'
                  }
                </p>
              </div>{' '}
              <aside
                className='evidence'
                data-reveal='fade'
                data-slot='evidence'
              >
                {' '}
                <span className='eyebrow'>{'From our checks'}</span>{' '}
                <div className='evidence__stat'>
                  <span data-count='30'>{'30'}</span>
                  <small>{'of 291 sites'}</small>
                </div>{' '}
                <p className='evidence__text'>
                  {
                    'Of 291 sites checked with this tool between 22 May 2026 and 25 Sep 2026, 30 had a robots.txt rule blocking at least one AI search, user or training crawler.'
                  }
                </p>
                <p className='evidence__text'>
                  {
                    'Blocking a training crawler is a content-use choice. Blocking a search crawler is a different decision: OpenAI says sites that block OAI-SearchBot will not be shown in ChatGPT search answers, and Anthropic says blocking Claude-SearchBot may reduce your visibility in user search results.'
                  }
                </p>{' '}
                <p className='evidence__fine'>
                  {
                    'Latest check per site, host-level counts only; our own sites, blocked scans and ungraded results excluded. These are sites people chose to check, not a sample of the web. Counted 26 Sep 2026.'
                  }
                </p>{' '}
              </aside>{' '}
            </div>{' '}
            <div className='stack explain' data-slot='explainers'>
              <div className='stack-block' data-reveal=''>
                {' '}
                <div className='block__label'>
                  <h3 className='h-display h3'>
                    {'Search crawlers and training crawlers do different jobs'}
                  </h3>
                </div>{' '}
                <div className='explain__body'>
                  {' '}
                  <div className='tbl'>
                    <table>
                      <thead>
                        <tr>
                          <th>{'Crawler type'}</th>
                          <th>{'Examples'}</th>
                          <th>{'What it is for'}</th>
                          <th>{'What the vendor says about blocking it'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{'Training'}</td>
                          <td className='m'>{'GPTBot, ClaudeBot'}</td>
                          <td>
                            {
                              'Collect content that may be used to train AI models'
                            }
                          </td>
                          <td>
                            {
                              'Anthropic: restricting ClaudeBot signals that your future content should be excluded from its training data.'
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>{'Search'}</td>
                          <td className='m'>
                            {'OAI-SearchBot, Claude-SearchBot, PerplexityBot'}
                          </td>
                          <td>
                            {
                              "Surface and link pages in the assistant's search results"
                            }
                          </td>
                          <td>
                            {
                              'OpenAI: sites that disallow OAI-SearchBot will not be shown in ChatGPT search answers, though they can still appear as navigational links. Anthropic: blocking Claude-SearchBot may reduce your visibility in user search results. Perplexity: PerplexityBot is not used to train AI foundation models; its page does not say what blocking does.'
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>{'User-triggered'}</td>
                          <td className='m'>{'ChatGPT-User, Claude-User'}</td>
                          <td>
                            {'Fetch a page when a person asks the assistant to'}
                          </td>
                          <td>
                            {
                              'OpenAI: robots.txt rules may not apply to ChatGPT-User, because a person starts the fetch. Anthropic: disabling Claude-User may reduce your visibility for user-directed web search.'
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>{' '}
                  <p>
                    {
                      'To stay in ChatGPT search answers, make sure your robots.txt does not disallow OAI-SearchBot. An explicit rule looks like this:'
                    }
                  </p>{' '}
                  <pre className='code'>
                    <span className='k'>{'User-agent:'}</span>
                    {' OAI-SearchBot\n'}
                    <span className='k'>{'Allow:'}</span>
                    {' /'}
                  </pre>{' '}
                  <p className='srcnote'>
                    {'Sources: '}
                    <a
                      href='https://developers.openai.com/api/docs/bots'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {'OpenAI crawler docs'}
                    </a>
                    {', '}
                    <a
                      href='https://support.claude.com/en/articles/8896518'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {"Anthropic's crawler article"}
                    </a>
                    {' and '}
                    <a
                      href='https://docs.perplexity.ai/guides/bots'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {"Perplexity's bot docs"}
                    </a>
                    {', checked 26 Sep 2026.'}
                  </p>
                </div>{' '}
              </div>
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--ink sheet--pad'
          id='checks'
          data-rail='What we check'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head sec-head--split' data-reveal=''>
              {' '}
              <div style={{ display: 'grid', gap: '22px' } as CSSProperties}>
                <span className='eyebrow'>{'02 / What we check'}</span>
                <h2 className='h-display h2' data-slot='checks.title'>
                  {'What we '}
                  <span className='serif'>{'check.'}</span>
                </h2>
              </div>{' '}
              <p className='lede'>
                {
                  '4 checks, each with a plain-English reason it matters. Every one maps to a line in the report.'
                }
              </p>{' '}
            </div>{' '}
            <div
              className='wgrid reveal-stagger'
              data-reveal=''
              data-slot='checks.items'
              data-n='4'
            >
              <div className='wcard'>
                <span className='mono'>
                  <span>{'01'}</span>
                  <span>{'AI Crawl Checker'}</span>
                </span>
                <h3>{'17 Bot User-Agents'}</h3>
                <p>
                  {
                    'HEAD requests as Googlebot, OAI-SearchBot, Claude-SearchBot, PerplexityBot, GPTBot, and more.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'02'}</span>
                  <span>{'AI Crawl Checker'}</span>
                </span>
                <h3>{'robots.txt Analysis'}</h3>
                <p>
                  {
                    'Parse allow/disallow rules per bot, sitemap directive, and crawl-delay.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'03'}</span>
                  <span>{'AI Crawl Checker'}</span>
                </span>
                <h3>{'Structured Data'}</h3>
                <p>
                  {
                    'JSON-LD extraction: Article, FAQPage, Organization, Product, BreadcrumbList.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'04'}</span>
                  <span>{'AI Crawl Checker'}</span>
                </span>
                <h3>{'llms.txt Detection'}</h3>
                <p>
                  {
                    'Check for the emerging standard that helps AI understand your site.'
                  }
                </p>
              </div>
              <div className='wcard wcard--fill' aria-hidden='true'>
                <b>{'4'}</b>
                <span>{'checks in every report'}</span>
              </div>
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='scoring'
          data-rail='Scoring'
          style={
            {
              borderRadius: 'var(--radius-sheet) var(--radius-sheet) 0 0',
              marginTop: 'calc(var(--radius-sheet) * -1)',
              paddingBottom: 'var(--section)',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head' data-reveal=''>
              {' '}
              <span className='eyebrow'>{'03 / Scoring'}</span>{' '}
              <h2 className='h-display h2' data-slot='scoring.title'>
                {'How We Score '}
                <span className='serif'>{"(And Why It's Different)"}</span>
              </h2>{' '}
            </div>{' '}
            <div className='score'>
              {' '}
              <div className='score__label' data-reveal=''>
                {' '}
                <div className='score__total'>
                  <span data-count='100'>{'100'}</span>
                  <small>{'points'}</small>
                </div>{' '}
                <p data-slot='scoring.intro'>
                  {
                    'Most crawl checkers stop at robots.txt. We score what actually determines whether AI systems cite you: structured data quality, llms.txt presence, and content accessibility. This methodology comes from our own work optimizing for AI search.'
                  }
                </p>{' '}
              </div>{' '}
              <div
                className='srows'
                data-reveal='fade'
                data-slot='scoring.items'
              >
                <div className='srow'>
                  <span className='srow__i'>{'01'}</span>
                  <div>
                    <div className='srow__n'>{'Bot Access & robots.txt'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '40%' } as CSSProperties} />
                    </div>
                    <p className='srow__d'>
                      {
                        "Do AI retrieval bots (OAI-SearchBot, Claude-SearchBot, PerplexityBot) have access? Is there a deliberate policy for training crawlers? A smart robots.txt isn't just allow/block. It's a strategy."
                      }
                    </p>
                  </div>
                  <div className='srow__p'>
                    <span data-count='40'>{'40'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'02'}</span>
                  <div>
                    <div className='srow__n'>{'Structured Data'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '25%' } as CSSProperties} />
                    </div>
                    <p className='srow__d'>
                      {
                        'JSON-LD is how machines understand your content. We check for page-type-appropriate schema: Organization for homepages, Article for posts, BreadcrumbList for navigation. FAQPage also scores, though Google stopped showing FAQ rich results on May 7, 2026.'
                      }
                    </p>
                  </div>
                  <div className='srow__p'>
                    <span data-count='25'>{'25'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'03'}</span>
                  <div>
                    <div className='srow__n'>{'llms.txt'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '20%' } as CSSProperties} />
                    </div>
                    <p className='srow__d'>
                      {
                        'A proposed file that summarizes your site for language models. We score structure, entity definitions, URLs, and use policy. It is optional: Google says Google Search ignores it, and no major AI engine documents using it to choose citations.'
                      }
                    </p>
                  </div>
                  <div className='srow__p'>
                    <span data-count='20'>{'20'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'04'}</span>
                  <div>
                    <div className='srow__n'>{'Content Quality'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '15%' } as CSSProperties} />
                    </div>
                    <p className='srow__d'>
                      {
                        'Can AI crawlers actually read your content without executing JavaScript? We check server-side rendering, title/description length, and framework detection.'
                      }
                    </p>
                  </div>
                  <div className='srow__p'>
                    <span data-count='15'>{'15'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='research'
          data-rail='Research'
          style={
            {
              '--bg': 'var(--paper-2)',
              paddingBottom: 'var(--section)',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='research'>
              {' '}
              <div
                className='research__copy'
                data-reveal=''
                data-slot='research.copy'
              >
                {' '}
                <span className='eyebrow'>{'04 / Research'}</span>{' '}
                <h2
                  className='h-display h3'
                  style={
                    { fontSize: 'clamp(30px,3.6vw,52px)' } as CSSProperties
                  }
                >
                  {'Built on our own research'}
                </h2>{' '}
                <p>
                  {
                    'This tool reflects what we learned optimizing pixelmojo.io for AI search. Every scoring criterion comes from real implementation and measurable results, not theory.'
                  }
                </p>{' '}
              </div>{' '}
              <div data-reveal='fade'>
                <div className='reading' data-slot='research.links'>
                  <Link href='/blogs/build-brand-ai-search-engines-cite'>
                    <span className='mono'>{'Brand'}</span>
                    <b>{'How to Build a Brand That AI Search Engines Cite'}</b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/knowledge-graph-llm-visibility-real-data'>
                    <span className='mono'>{'Structured data'}</span>
                    <b>
                      {'How We Built a Knowledge Graph That LLMs Actually Cite'}
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/llms-txt-static-vs-dynamic-implementation-guide'>
                    <span className='mono'>{'llms.txt'}</span>
                    <b>
                      {"Your llms.txt Is Already Stale. Here's How to Fix It."}
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/geo-playbook-get-cited-chatgpt-perplexity-claude'>
                    <span className='mono'>{'GEO'}</span>
                    <b>{'The GEO Playbook'}</b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/optimized-ai-search-pixelmojo-results'>
                    <span className='mono'>{'Dated note'}</span>
                    <b>
                      {
                        'What We Changed for AI Search by February 2026 (Dated Note)'
                      }
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/seo-vs-geo-vs-aeo-guide-2026'>
                    <span className='mono'>{'Strategy'}</span>
                    <b>
                      {
                        'SEO vs AEO vs GEO: From Ranking in Search to Becoming the Recommended Brand'
                      }
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                </div>
                <p className='reading__note'>
                  {'Related: the '}
                  <Link href='/blogs/free-ai-visibility-tools-complete-guide'>
                    {'free AI visibility tools guide'}
                  </Link>
                  {', the '}
                  <Link href='/tools/robots-txt-analyzer'>
                    {'robots.txt Analyzer'}
                  </Link>
                  {' and the '}
                  <Link href='/tools/ai-readiness-score'>
                    {'AI Readiness Checker'}
                  </Link>
                  {'.'}
                </p>
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage'
          id='related'
          data-rail='Related tools'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container rel'>
            {' '}
            <div className='sec-head sec-head--split' data-reveal=''>
              {' '}
              <div style={{ display: 'grid', gap: '22px' } as CSSProperties}>
                <span className='eyebrow'>{'05 / Related free tools'}</span>
                <h2 className='h-display h2' data-slot='related.title'>
                  {'Related free '}
                  <span className='serif'>{'tools.'}</span>
                </h2>
              </div>{' '}
              <Link className='btn btn--ghost' href='/tools'>
                {'Browse all tools'}
                <svg
                  className='arrow'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.8'
                >
                  <path d='M5 12h14M13 6l6 6-6 6' />
                </svg>
              </Link>{' '}
            </div>{' '}
            <div
              className='tgrid reveal-stagger'
              data-reveal=''
              data-slot='related.items'
              data-n='4'
            >
              <Link className='tcard' href='/tools/robots-txt-analyzer'>
                <div className='tcard__top'>
                  <span>{'16 bots'}</span>
                </div>
                <h3>{'robots.txt Analyzer'}</h3>
                <p>{'Check which AI bots your robots.txt allows.'}</p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/ai-readiness-score'>
                <div className='tcard__top'>
                  <span>{'Unified'}</span>
                </div>
                <h3>{'AI Readiness Score'}</h3>
                <p>{'See your overall AI-search readiness in one score.'}</p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/llms-txt-validator'>
                <div className='tcard__top'>
                  <span>{'Deep scan'}</span>
                </div>
                <h3>{'llms.txt Validator'}</h3>
                <p>
                  {
                    'Deep-scan your llms.txt against the emerging specification.'
                  }
                </p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/free-ai-visibility-checker'>
                <div className='tcard__top'>
                  <span>{'Overview'}</span>
                </div>
                <h3>{'Free AI Visibility Checker'}</h3>
                <p>
                  {
                    'Plain-English AI visibility check on the AI Readiness Score engine.'
                  }
                </p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--ink sheet--pad'
          id='radar'
          data-rail='Radar'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container radarband'>
            {' '}
            <div
              data-reveal=''
              style={{ display: 'grid', gap: '22px' } as CSSProperties}
            >
              {' '}
              <span className='eyebrow'>{'Radar'}</span>{' '}
              <h2 className='h-display h2'>
                {'Want the full picture across four '}
                <span className='serif'>{'AI engines?'}</span>
              </h2>{' '}
              <p className='lede'>
                {
                  'Radar orchestrates 13 AI visibility audits in staged batches: crawl access, llms.txt, structured data, brand citations, and more. It then surfaces cross-tool conflicts and ships a prioritized action plan for your domain.'
                }
              </p>{' '}
              <div className='hero__cta'>
                {' '}
                <Link className='btn btn--accent' href='/platform#free-audit'>
                  {'Get My Free Snapshot '}
                  <svg
                    className='arrow'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='1.8'
                  >
                    <path d='M5 12h14M13 6l6 6-6 6' />
                  </svg>
                </Link>{' '}
                <Link
                  className='btn btn--ghost'
                  href='/services/ai-visibility-strategy'
                >
                  {'Or book a strategy session'}
                </Link>{' '}
              </div>{' '}
            </div>{' '}
            <div
              className='scope'
              data-reveal='fade'
              aria-label='Radar sweep across four AI engines'
            >
              {' '}
              <canvas id='scope' />{' '}
              <div className='scope__tags' aria-hidden='true'>
                {' '}
                <span className='scope__tag' data-tag='0'>
                  {'ChatGPT'}
                </span>
                <span className='scope__tag' data-tag='1'>
                  {'Claude'}
                </span>
                <span className='scope__tag' data-tag='2'>
                  {'Gemini'}
                </span>
                <span className='scope__tag' data-tag='3'>
                  {'Perplexity'}
                </span>{' '}
              </div>{' '}
              <div className='scope__meta'>
                {'Sweep · '}
                <b id='sweepDeg'>{'000°'}</b>
                {' · 13 checks · one pass'}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--accent cta sheet--pad'
          id='start'
          data-rail='Start'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='cta__ghost' aria-hidden='true'>
            {'FREE'}
          </div>{' '}
          <div className='container cta__inner'>
            {' '}
            <div
              data-reveal=''
              style={{ display: 'grid', gap: '22px' } as CSSProperties}
            >
              {' '}
              <span className='eyebrow'>{'Start now'}</span>{' '}
              <h2 className='h-display' data-slot='cta.title'>
                {'Run it on your site. See what AI '}
                <span className='serif'>{'can read.'}</span>
              </h2>{' '}
              <p
                className='lede'
                style={{ color: 'rgba(18,18,18,.72)' } as CSSProperties}
                data-slot='cta.text'
              >
                {
                  'Free, no account, result on this page. When you want the whole picture, Radar runs all 13 audits in one pass.'
                }
              </p>{' '}
            </div>{' '}
            <div className='hero__cta' data-reveal='fade'>
              <a className='btn' href='#run'>
                {'Analyze'}
                <svg
                  className='arrow'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.8'
                >
                  <path d='M5 12h14M13 6l6 6-6 6' />
                </svg>
              </a>
              <Link className='btn btn--ghost' href='/tools'>
                {'Browse all tools'}
              </Link>
            </div>{' '}
          </div>{' '}
        </section>{' '}
      </div>{' '}
      <RefScript code={SCRIPT} />
    </>
  )
}
